import { Avatar, Badge, Group, Paper, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconCircleCheckFilled } from "@tabler/icons-react";
import dayjs from "dayjs";
import { Review } from "../../Model/Review.model";
import ReviewStars from "./ReviewStars";

interface ReviewCardProps {
  review: Review;
  compact?: boolean;
}

function ReviewCard({ review, compact = false }: ReviewCardProps) {
  const theme = useMantineTheme();

  return (
    <Paper
      withBorder
      radius="xl"
      p={compact ? "lg" : "xl"}
      className="subjectbuddy-review-card"
    >
      <Stack gap={compact ? "sm" : "md"}>
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <Group gap="sm" wrap="nowrap" align="flex-start">
            <Avatar radius="xl" color="green" size={compact ? 44 : 52} name={review.name} />
            <Stack gap={2}>
              <Group gap={8} wrap="wrap">
                <Text fw={800}>{review.name}</Text>
                {review.verified ? (
                  <Badge
                    variant="light"
                    color="green"
                    leftSection={<IconCircleCheckFilled size={12} />}
                    radius="sm"
                  >
                    Verified
                  </Badge>
                ) : null}
              </Group>
              <Text size="sm" c="dimmed">
                {review.subject} · {review.country}
              </Text>
            </Stack>
          </Group>
          <Badge variant="outline" color="blue" radius="sm">
            {review.category}
          </Badge>
        </Group>

        <Group justify="space-between" wrap="wrap" gap="xs">
          <ReviewStars rating={review.rating} showValue />
          <Text size="sm" c="dimmed">
            {dayjs(review.datedOn).format("D MMM YYYY")}
          </Text>
        </Group>

        <Stack gap={6}>
          <Text
            fw={800}
            size={compact ? "md" : "lg"}
            c={theme.colors.green[9]}
            style={{ lineHeight: 1.25 }}
          >
            {review.title}
          </Text>
          <Text c="dimmed" style={{ lineHeight: 1.8 }}>
            {review.comment}
          </Text>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default ReviewCard;
